export const PAGE_TARNSALATION_KEYS = {
    mytrips: {
        description: 'mytrips.traveler.app.banner.description',
        title: 'mytrips.traveler.app.banner.title',
        buttonLabel: 'mytrips.traveler.app.banner.button.label',
        closeButtonText: 'mytrips.traveler.app.modal.close.button.label'
    },
    confirmation: {
        description: 'confirmation.traveler.app.description',
        title: 'mytrips.traveler.app.banner.title',
        buttonLabel: 'mytrips.traveler.app.banner.button.label',
        closeButtonText: 'mytrips.traveler.app.modal.close.button.label',
        embeddedTitle: 'confirmation.traveler.app.embedded.title',
        embeddedButtonLabel: 'confirmation.traveler.app.embedded.button.label'
    },
    inbox: {
        description: 'inbox.traveler.app.banner.description',
        title: 'inbox.traveler.app.banner.title',
        buttonLabel: 'inbox.traveler.app.banner.button.label',
        closeButtonText: 'inbox.traveler.app.modal.close.button.label',
    },
    serp: {
        description: 'serp.traveler.app.banner.description',
        title: 'serp.traveler.app.banner.title',
        buttonLabel: 'serp.traveler.app.banner.button.label',
        closeButtonText: 'serp.traveler.app.modal.close.button.label',
    },
    homepage: {
        description: 'homepage.traveler.app.banner.description',
        description_v1: 'homepage.traveler.app.banner.description.v1',
        modal_description: 'homepage.traveler.app.modal.description',
        modal_title: 'homepage.traveler.app.modal.title',
        title: 'homepage.traveler.app.banner.title',
        title_v1: 'homepage.traveler.app.banner.title.v1',
        modal_buttonLabel: 'homepage.traveler.app.modal.button.label',
        buttonLabel: 'homepage.traveler.app.banner.button.label',
        closeButtonText: 'homepage.traveler.app.modal.close.button.label',
    },
    common: {
        ratings: 'traveler.app.banner.ratings'
    }
};
